<template>
    <div class="main">
        <div class="container mx-auto px-6 xl:px-0 pb-12">
            <div class="text-center">
                <h1 class="my-10" v-text="$t('IMPRESSUM')"></h1>
            </div>
            <div class="text-left w-full lg:w-1/2 mx-auto">
                <p class="my-4"><span class="font-bold pr-2" v-text="$t('IMPRESSUM_COMPANY_NAME_LABEL')"></span></p>
                <p>{{$t('IMPRESSUM_COMPANY_NAME')}}</p>
                <p v-html="$t('IMPRESSUM_COMPANY_ADDRESS')"></p>
                <p class="my-4"><span class="font-bold pr-2" v-text="$t('IMPRESSUM_COMPANY_TELEPHONE_LABEL')"></span>{{$t('COMPANY_TELEPHONE', {contactNumber})}}</p>
                <p class="my-4">
                    <span class="font-bold pr-2" v-text="$t('IMPRESSUM_COMPANY_EMAIL_LABEL')"></span>
                    <a class="underline hover:no-underline" :href="`mailto:${email}`">{{email}}</a>
                </p>
                <p class="my-4"><span class="font-bold pr-2" v-text="$t('IMPRESSUM_COMPANY_REG_NO_LABEL')"></span>{{$t('IMPRESSUM_COMPANY_REG_NO')}}</p>
                <p class="my-4"><span class="font-bold pr-2" v-text="$t('IMPRESSUM_COMPANY_VAT_ID')"></span>{{$t('IMPRESSUM_COMPANY_VAT_ID_NO')}}</p>
                <h2 class="my-10 text-center" v-text="$t('IMPRESSUM_DISPUTE_RESOLUTION_LABEL')"></h2>
                <p class="my-4 text-center" v-html="$t('IMPRESSUM_DISPUTE_RESOLUTION')"></p>
                <h2 class="my-4 text-center" v-text="$t('IMPRESSUM_FAIR_COMMERCE_LABEL')"></h2>
                <p class="my-4 text-center" v-html="$t('IMPRESSUM_FAIR_COMMERCE')"></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Impressum',
    data() {
        return {
            email: process.env.VUE_APP_EMAIL,
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
};
</script>
